import { createStore as baseCreateStore, useStore as baseUseStore } from 'vuex';

import { RootState, Store } from '@/store/@types/index';

import base from './modules/base';
import auth from './modules/auth';
import calendar from './modules/calendar';
import chat from './modules/chat';
import myPlants from './modules/my-plants';
import plant from './modules/plant';
import pricing from './modules/pricing';
import subscriptions from './modules/subscriptions';
import onboarding from './modules/onboarding';

const modules = {
  base,
  auth,
  calendar,
  chat,
  plant,
  pricing,
  subscriptions,
  onboarding,
  'my-plants': myPlants,
};

export const useStore = () => baseUseStore<RootState>() as Store;
export const createStore = () => baseCreateStore<RootState>({ modules });

export const store = createStore();
